import React, { useContext, useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import { projectSwitchSchema } from '../Register/schema';
import { ParamsContext } from '../Context/ParamsContext';
import { Card, Col, message, Row } from 'antd';
import axios from '../../util/Api';
import SwitchForm from './SwitchForm';
import Title from '../../components/Title/Title';
import Item from '../../components/Detail/Item';
import ProjectHistory from '../Passport/Detail/ProjectHistory';
import { useHistory } from 'react-router-dom';

const Switch = (props) => {
  const history = useHistory();
  const { id } = useContext(ParamsContext);
  const [loading, setLoading] = useState(true);
  const [passport, setPassport] = useState({});

  useEffect(() => {
    fetchPassportDetail();
  }, [id]);

  const fetchPassportDetail = () => {
    setLoading(true);
    const url = `/passport/detail?id=${id}`;
    axios.get(url).then(resp => {
      if (!resp.data.actions.switch_project) {
        message.error('Anda tidak dapat melakukan proses pindah proyek karena sedang dalam masa verifikasi');
        history.push(`/passport/detail?id=${id}`);
      };
      setPassport(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data personel");
    });
  }

  return (
    <>
      <Title>Registrasi Akses Masuk Proyek</Title>
      {loading ? "Sedang memuat..." : <Formik
        initialValues={{
          project: {
            id: undefined,
            division: undefined,
            start: "",
            end: "",
            before: passport.active_project.project.id
          }
        }}
        validationSchema={projectSwitchSchema}
        onSubmit={values => {
          const data = {
            id: passport.id,
            before: passport.active_project,
            after: values.project
          };
          const url = `/passport/switch-project`;
          axios.post(url, data).then(resp => {
            if (resp.data.success) {
              message.success(resp.data.message);
              history.push(`/passport/detail?id=${id}`);
            } else {
              message.error('Pindah proyek gagal disimpan');
            }
          }).catch(err => {
            message.error('Pindah proyek gagal disimpan');
          });
        }}
      >
        {(formik) => {
          console.log(formik.values);
          return (
            <Form>
              <Row>
                <Col span={18}>
                  <Card className="gx-card" title="Informasi Personel">
                    <Item label={`Nama`} value={passport.name} />
                    <Item label={`No Identitas`} value={passport.identity.number} />
                    <Item label={`Jenis Kelamin`} value={passport.gender} />
                    <Item label={`Perusahaan`} value={passport.vendor.name} />
                    {passport.active_project ? (
                      <Item label={`Divisi Operasi`} value={passport.active_project.division.label} />
                    ) : null}
                  </Card>
                  <SwitchForm />
                  <ProjectHistory passport={passport} />
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>}
    </>
  );
}

export default Switch;